import axios from 'axios';

export default {
    /**
     * Get jobs locations
     *
     * @return {Array}
     */
    async getLocations() {
        try {
            return await axios.get(`/wp-json/swp/pj/locations`).then(response => response.data);
        } catch {
            return [];
        }
    },
    /**
     * Get jobs filters
     *
     * @return {Array}
     */
    async getFilters() {
        try {
            return await axios.get(`/wp-json/swp/pj/filters`).then(response => response.data);
        } catch {
            return [];
        }
    },
    /**
     * Get jobs list
     *
     * @param {Object} params
     * @return {Object}
     */
    async getJobsList(params = {}) {
        try {
            return await axios.get(`/wp-json/swp/pj/jobs-list`, {
                params
            }).then(response => response.data);
        } catch {
            return {};
        }
    },
    /**
     * Get jobs list
     * @param {Object} params
     * @return {Object}
     */
    async getJob(params = {}) {
        try {
            return await axios.get(`/wp-json/swp/pj/job`, {
                params
            }).then(response => response.data);
        } catch {
            return {};
        }
    },
    /**
     * Get jobs location
     * @param {Object} params
     * @return {Object}
     */
    async getLocation(params = {}) {
        try {
            return await axios.get(`/wp-json/swp/pj/location`, {
                params
            }).then(response => response.data);
        } catch {
            return {};
        }
    },
};
